import { render, staticRenderFns } from "./TalkBox.vue?vue&type=template&id=932db3de"
import script from "./TalkBox.vue?vue&type=script&lang=js"
export * from "./TalkBox.vue?vue&type=script&lang=js"
import style0 from "./TalkBox.vue?vue&type=style&index=0&id=932db3de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports